export const sanitizeNumber = (value, fallback = 0) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
};

export const sanitizeString = (value, fallback = '') => {
    if (typeof value === 'string') {
        return value.trim();
    }
    return typeof value === 'number' || typeof value === 'boolean'
        ? String(value)
        : fallback;
};

export const sanitizeBoolean = (value, fallback = false) => {
    return typeof value === 'boolean' ? value : fallback;
};

const methodFallbacks = {
    processVideo: ['', '', '', 16, 30, 'output.mp4'],
    processVideoWatermark: ['', '', '', 16, 30, 'output.mp4'],
    processImage: ['', 16, 44100, 1280, 720, 30, 3, /*1.7777777777777777,*/ 'output.mp4'],
    processVideoOverlay: [30, 'output.mp4'],
    processConcat: ['', 'output.mp4'/*, 1.7777777777777777*/],
    cleanupResources: [],
};

export const safeElectronCall = async (method, ...args) => {
    if (!window.electron || typeof window.electron[method] !== 'function') {
        return null;
    }
    const fallbacks = methodFallbacks[method] || [];

    const sanitizedArgs = args.map((arg, index) => {
        const fb = fallbacks[index];
        if (typeof arg === 'number' || typeof fb === 'number') {
            return sanitizeNumber(arg, typeof fb === 'number' ? fb : 0);
        }
        if (typeof arg === 'boolean' || typeof fb === 'boolean') {
            return sanitizeBoolean(arg, typeof fb === 'boolean' ? fb : false);
        }
        if (typeof arg === 'string' || typeof fb === 'string') {
            return sanitizeString(arg, typeof fb === 'string' ? fb : '');
        }
        return arg ?? (fb ?? null);
    });

    try {
        return await window.electron[method](...sanitizedArgs);
    } catch (error) {
        throw error;
    }
};